<div class="lv-artefact-container lv-component"
     [ngClass]="!!uiArtefakt?.Ausrichtung ? uiArtefakt?.Ausrichtung : uiAusrichtung">
  <ng-container *ngIf="uiArtefakt.Color.toLowerCase() === 'link'">
    <a class="lv-button-alignment" mat-raised-button
            [disabled]="isDisabled"
            (click)="onButtonClicked()">
      {{uiArtefakt.Text}}
    </a>
  </ng-container>
  <ng-container *ngIf="uiArtefakt.Color.toLowerCase() !== 'link'">
  <button class="lv-button-alignment" mat-raised-button color="{{uiArtefakt.Color.toLowerCase()}}"
          [disabled]="isDisabled"
          (click)="onButtonClicked()">
    {{uiArtefakt.Text}}
  </button>
  </ng-container>
</div>
